import { render, staticRenderFns } from "./empresa-details.vue?vue&type=template&id=320d4b4a&scoped=true&"
import script from "./empresa-details.vue?vue&type=script&lang=js&"
export * from "./empresa-details.vue?vue&type=script&lang=js&"
import style0 from "./empresa-details.vue?vue&type=style&index=0&id=320d4b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d4b4a",
  null
  
)

export default component.exports